/*
 * Las estrellas junto al H1 de la ficha bajan a las opiniones (Tamara,
 * 23/09/2026: «si pinchan que vayan a la parte de abajo donde estarian todas
 * las valoraciones»). El enlace ya es un ancla (`#opiniones`) y funciona sin
 * esto; el script solo lo hace con desplazamiento suave, salvo con
 * `prefers-reduced-motion`. La cabecera fija no tapa el titular porque la
 * banda lleva `scroll-margin-block-start` (seccion 57 del CSS), que
 * `scrollIntoView` respeta.
 *
 * Por delegacion en `document`: `theme dev` sustituye la seccion al recargar
 * y un oyente puesto en el nodo se perderia.
 */
(() => {
  if (window.__nnEstrellas) return;
  window.__nnEstrellas = true;

  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest('.nn-resenas-resumen a[href^="#"]');
    if (!enlace) return;
    const id = decodeURIComponent(enlace.getAttribute('href').slice(1));
    const destino = id && document.getElementById(id);
    if (!destino) return;
    evento.preventDefault();
    const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destino.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();
